import {SET_SEARCHTERM_MOVIES, SET_SEARCHTERM_SERIES} from "../constants/vod-action-types";

export function setSearchtermMovies(searchTerm) {
    return{type: SET_SEARCHTERM_MOVIES, searchTermMovies: searchTerm};
}

export function setSearchtermSeries(searchTerm) {
    return{type: SET_SEARCHTERM_SERIES, searchTermSeries: searchTerm};
}
